import { Role } from '@/core/components/auth/auth.types'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/resellers/$resellerId/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role !== Role['Internal']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  component: () => <div>Hello /_layout/dashboard/resellers/$resellerId/!</div>,
})
